import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
//import { Globals } from "../../global/Globals";
import Button from "../../components/Button/Button";
import "./Login.css";
import fetchUser from "../../services/loginAPI";
import { setCreds } from "./LoginSlice";
import { useDispatch } from "react-redux";
import CryptoUtils from "../../util/cryptoUtils";
import LanguageSelector from "../../components/LanguageSelector/LanguageSelector";
import { useLanguage } from '../../context/Languagecontext';
import ProgressLoader from "../../components/ProgressLoader/ProgressLoader";
import {Globals as OldGlobals} from "../../global/Globals";
const Login = ({ setReset, renderToast }) => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const passwordRegex = Globals.REGEX.PASSWORD_REGEX;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isEmailValid, setEmailValid] = useState(true);
  const [isPasswordValid, setPasswordValid] = useState(true);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [emailValidationMessage, setEmailValidationMessage] = useState("");
  const [passwordValidationMessage, setPasswordValidationMessage] = useState("");
  const [isLoader, setIsLoader]=useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleEmail = (e) => {
    setEmailValid(true);
    setEmail(e.target.value);
  };
  const handlePassword = (e) => {
    setPasswordValid(true);
    setPassword(e.target.value);
  };
  const validateInputs = () => {
    setPasswordValidationMessage("");
    setEmailValidationMessage("");
    setPasswordValid(true);
    setEmailValid(true);
    validateCredentials();
  };

  const evaluateCredentials = (isValidEmail, isValidPassword) => {
    let checkFlag = true;
    if (email.length === 0) {
      setEmailValidationMessage(Globals.ERROR_MESSAGES.EMPTY_EMAIL);
      checkFlag = false;
    } else if (!isValidEmail) {
      setEmailValidationMessage(Globals.ERROR_MESSAGES.INVALID_EMAIL_FORMAT);
      checkFlag = false;
    }
    if (password.length === 0) {
      setPasswordValid(false);
      setPasswordValidationMessage(Globals.ERROR_MESSAGES.EMPTY_PASSWORD);
      checkFlag = false;
    } else if (!isValidPassword) {
      setPasswordValid(false);
      setPasswordValidationMessage(Globals.ERROR_MESSAGES.INVALID_PASSWORD_FORMAT);
      checkFlag = false;
    }
    return checkFlag;
  };
  const validateCredentials = () => {
    const emailRegex = OldGlobals.REGEX.EMAIL_REGEX;
    const isValidEmail = email.match(emailRegex) ? true : false;
    const isValidPassword = password.match(passwordRegex) ? true : false;
    const checkFlag = evaluateCredentials(isValidEmail, isValidPassword);
    if (checkFlag) {
      setEmailValid(true);
      setPasswordValid(true);
      setEmailValidationMessage("");
      const api = fetchUser(email, password);
      setIsLoader(true);
      api
        .then((response) => {
          setIsLoader(false);
          if (response?.data?.content?.isSuccess) {
            const payload = { userName: email, password: password };
            dispatch(setCreds(payload));
            setEmailValid(true);
            const clusters = response?.data?.content?.clusters;
            const roleIds = response?.data?.content?.roles;
            const validClusters = Array.isArray(clusters) ? clusters : [];
            const validRoleIds = Array.isArray(roleIds) ? roleIds : [];
            CryptoUtils.saveToLocalStorage("isProducer", response.data.content.isProducer);
            CryptoUtils.saveToLocalStorage("userType", response.data.content.type);
            if (validClusters.length > 0) {
              const clusterName = JSON.stringify([
                {
                  clusterId: response.data.content.clusters[0].clusterId,
                  clusterName: response.data.content.clusters[0].clusterName,
                },
              ]);
              CryptoUtils.saveToLocalStorage("clusterName", response.data.content.clusorName);
              CryptoUtils.saveToLocalStorage("clusterName", clusterName);
              CryptoUtils.saveToLocalStorage(
                "clusters",
                validClusters.length > 0
                  ? JSON.stringify(validClusters)
                  : JSON.stringify([
                      { clusterId: 1, clusterName: "South Africa Premium Scripted" },
                      { clusterId: 2, clusterName: "South Africa" },
                    ])
              );
            }
            CryptoUtils.saveToLocalStorage(
              "roles",
              validRoleIds.length > 0 ? JSON.stringify(validRoleIds) : []
            );
            CryptoUtils.saveToLocalStorage("roleId", response.data.content.roleId);
            CryptoUtils.saveToLocalStorage("refreshToken", response.data.content.refreshToken);
            CryptoUtils.saveToLocalStorage("roleName", response.data.content.roleName);
            CryptoUtils.saveToLocalStorage("fullName", response.data.content.fullName);
            CryptoUtils.saveToLocalStorage("companyName", response.data.content.companyName);
            CryptoUtils.saveToLocalStorage("isConsent", response.data.content.isConsent);
            CryptoUtils.saveToCookie(
              Globals.JWT_TOKEN_NAME,
              response?.data?.content?.token,
              Globals.JWT_TOKEN_EXPIRY
            );
            navigate(Globals.NAVPATH.HOME);
          } else {
            setPasswordValid(false);
            // setEmailValid(false);
          }
        })
        .catch((error) => {
          setIsLoader(false);
          console.error("Error in calling Logi API===>", error);
          if (error?.response?.data?.status === "Unauthorized") {
            setPasswordValid(false);
            setPasswordValidationMessage(error?.response?.data?.reasonPhrase);
          } else {
            setPasswordValid(false);
          }

          // setEmailValid(false);
        });
    } else if (!isValidEmail) {
      setEmailValid(false);
    } else if (!isValidPassword) {
      setPasswordValid(false);
    }
  };
  const tooglePasswordView = () => {
    const passwordInput = document.getElementById("password-inp");
    const passwordType = passwordInput.getAttribute("type");
    if (passwordType === "password") {
      passwordInput.setAttribute("type", "text");
      setPasswordVisible(true);
    } else {
      passwordInput.setAttribute("type", "password");
      setPasswordVisible(false);
    }
  };

  const navigateToSignup = () => {
    navigate(Globals.NAVPATH.SIGNUP);
  };

  const handleEnterPress = (e) => {
    if (e.key === "Enter") {
      validateInputs();
    }
  };

  const handleOnLangChange = (e) => {
        const selectedLang = e.target.value;
        localStorage.setItem("lang", selectedLang);
        setLanguages(selectedLang); // trigger re-render
        window.dispatchEvent(new Event("storage")); // ensure same-tab update
      };
  return (
    <>
      <LanguageSelector ishome={true}/>
      <div id="login-page" className="login-page">
        <div id="title" className="login-page-title">
          <h3 className="login-page-title">{Globals.LOGIN.TITLE}</h3>
        </div>
        <div className="credentials-section">
        <div id="email" className="email">
          <label id="email-label" className="email-label">
            {Globals.LOGIN.EMAIL}
            <span id="mandatory" className="mandatory">
              {Globals.MANDATORY_FIELD}
            </span>
          </label>
          <input
            id="email-inp"
            className="email-inp"
            name="email"
            value={email}
            placeholder={Globals.LOGIN.EMAIL_PLACEHOLDER}
            onChange={handleEmail}
            required
          ></input>
          {!isEmailValid && (
            <>
              <img
                id="login-error-btn"
                className="login-error-btn"
                src={Globals.IMG.ERROR}
                alt="password error"
              />
              <label className="invalidCredential">
                {emailValidationMessage
                  ? emailValidationMessage
                  : Globals.ERROR_MESSAGES.EMAIL_ERROR}
              </label>
            </>
          )}
        </div>
        <div id="password" className="password">
          <label id="password-label" className="password-label">
            {Globals.LOGIN.PASSWORD}
            <span id="mandatory" className="mandatory">
              {Globals.MANDATORY_FIELD}
            </span>
          </label>
          <span className="password-inp-container">
            <input
              type="password"
              id="password-inp"
              className="password-inp"
              name="password"
              placeholder={Globals.LOGIN.PASSWORD_PLACEHOLDER}
              onChange={handlePassword}
              onKeyDown={handleEnterPress}
              required
            ></input>
            <img
              className="view-hide-password"
              src={!isPasswordVisible ? Globals.IMG.HIDE_PASSWORD : Globals.IMG.VIEW_PASSWORD}
              alt="view-hide"
              onClick={tooglePasswordView}
            />
          </span>
          {!isPasswordValid && (
            <div className="login-error-message-holder">
              <img
                id="login-error-btn"
                className="login-error-btn"
                src={Globals.IMG.ERROR}
                alt="password error"
              />
              <label className="error-msg-handler invalidCredential">
                {passwordValidationMessage
                  ? passwordValidationMessage
                  : Globals.ERROR_MESSAGES.EMAIL_ERROR}
              </label>
            </div>
          )}
          </div>
          <div
            id="forgot-password"
            className="forgot-password"
            onClick={() => {
              setReset(true);
            }}
          >
            {Globals.LOGIN.FORGOT_PASSWORD}
          </div>
        </div>
        <div>
          <Button title={Globals.LOGIN.LOGIN} action={validateInputs} additionalStyle="login-btn" />
        </div>
        <div id="register" className="register">
          <span>
            <span id="register-question" className="register-question">
              {Globals.LOGIN.ACCOUNT_QUESTION}
              <p id="signup" className="signup" onClick={navigateToSignup}>
                {Globals.LOGIN.REGISTER}
              </p>
              {Globals.LOGIN.NOW}
            </span>
          </span>
        </div>
        <div className="login-query-email-holder">
          <span className="login-query-email-string">{Globals.EMAIL_QUERY_STRING}</span>
          <br />
          <b className="login-query-email">{Globals.EMAIL_QUERY}</b>
        </div>
      </div>
      {isLoader&&<ProgressLoader height={50} width={50} component={"Reg"}/>}
    </>
  );
};
export default Login;
